export default __webpack_public_path__ + "static/media/logo-autopass-for-business.3f5aef97.svg";